<mat-toolbar color="primary">
  <mat-toolbar-row>
    @if (createMode) {
      <span>{{ 'modals.modal-survey-details.add-survey' | translate}}</span>
    }
    @if (!createMode) {
      <span>{{ 'modals.modal-survey-details.edit-survey' | translate}}</span>
    }
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="closeDialogue()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<app-survey-details
  [projectId]="data?.projectId"
  [surveyId]="data?.surveyId"
  [ckmMapID]="data?.ckm_map_id"
  (surveyAdded)="closeDialogue($event)"
  (canceled)="closeDialogue()"
  />
